import React from 'react';
import { LucideIcon, Database, Mail, AlertTriangle, Globe, Network, Server } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface FeatureCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ title, description, icon: Icon }) => {
  return (
    <div className="group relative overflow-hidden rounded-lg bg-gray-800 p-8 shadow-lg transition-all hover:shadow-xl border border-gray-700 hover:border-blue-500">
      <div className="relative z-10">
        <div className="mb-4 inline-block rounded-lg bg-blue-100 p-3">
          <Icon className="h-8 w-8 text-blue-500" />
        </div>
        <h3 className="mb-2 text-lg font-semibold text-white">{title}</h3>
        <p className="text-gray-300 text-sm">{description}</p>
      </div>
      <div className="absolute inset-0 z-0 bg-gradient-to-br from-blue-900/30 to-transparent opacity-0 transition-opacity group-hover:opacity-100" />
    </div>
  );
};

const features = [
  { key: 'dataBreaches', icon: Database },
  { key: 'domainEmails', icon: Mail },
  { key: 'vulnerabilities', icon: AlertTriangle },
  { key: 'typosquatting', icon: Globe },
  { key: 'relatedIPs', icon: Network },
  { key: 'similarCompanies', icon: Server }
];

const ScannerFeatures: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="my-12">
      <h3 className="text-2xl font-bold text-white text-center mb-8">{t('scan.features.title')}</h3>
      <p className="text-lg text-gray-300 text-center max-w-4xl mx-auto mb-8">{t('scan.features.subtitle')}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {features.map((feat, idx) => (
          <FeatureCard
            key={idx}
            title={t(`scan.features.${feat.key}.title`)}
            description={t(`scan.features.${feat.key}.description`)}
            icon={feat.icon}
          />
        ))}
      </div>
    </div>
  );
};

export default ScannerFeatures;
